export default __webpack_public_path__ + "static/media/node-js.e328955d.png";